import React, { useState, Component } from "react";
import "./Modal.css";
import "./SectionsDialog.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Modal } from "react-bootstrap";
import AlertModal from "./AlertModal";
import PromptModal from "./PromptModal";
import HTMLEditorModal from "./HTMLEditorModal";
import Section from "../../Models/Section";

class SectionDialog extends Component {
  constructor(props) {
    super(props);
    let chapterSections = [];
    if (window.guide_obj != null) chapterSections = window.guide_obj.getChaptersSectionsToDisplay();
    this.state = {
      chapterSections: chapterSections,
      searchText: "",

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],
      ImageDialogShow: false,

      PromptModalShow: false,
      PromptModalTitle: "Enter Value",
      PromptModalMessage: "",
      PromptModalButtons: [],
      PromptModalInputs: [],

      HTMLEditorModalShow: false,
      HTMLEditorModalContent: "",
    };
  }

  MyAlert = (title, message, buttons) => {
    this.setState({
      AlertModalTitle: title,
      AlertModalMessage: message,
      AlertModalButtons: buttons,
      AlertModalShow: true,
    });
  };

  chapterClicked = (chapter) => {
    console.log("sectionHeaderClicked", chapter.Title);
  };

  sectionClicked = (section) => {
    console.log("sectionClicked", section.Title);
    if (this.props.mode === "select") {
      this.props.callback(section);
      this.props.onHide();
    }
  };

  handleSearchChanged = (event, text) => {
    let chapterSections = window.guide_obj.getChaptersSectionsToDisplay();
    let temp_list = [];
    const _searchText = event == null ? text : event.target.value.toUpperCase();
    chapterSections.forEach((chapter) => {
      if (chapter.Title.toUpperCase().includes(_searchText)) {
        temp_list.push(chapter);
        return;
      }
      let _chapter = JSON.parse(JSON.stringify(chapter));
      _chapter.data = [];
      chapter.data.forEach((section) => {
        if (section.Title.toUpperCase().includes(_searchText)) {
          _chapter.data.push(section);
        }
      });
      if (_chapter.data.length !== 0) temp_list.push(_chapter);
    });
    this.setState({ chapterSections: temp_list, searchText: event == null ? text : event.target.value });
  };

  deleteChapter = (chapter) => {
    this.MyAlert("Confirmation", "Confirm Delete Chapter?", [
      { Title: "OK", Method: () => this._deleteChapter(chapter) },
      { Title: "CANCEL", Method: null },
    ]);
  };

  _deleteChapter = (chapter) => {
    window.guide_obj.deleteChapter(chapter.ID);
    this.handleSearchChanged(null, this.state.searchText);
    this.props.update_display();
  };

  _chapter = null;
  addModifyChapter = (add, chapter) => {
    this._chapter = chapter;
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "Chapter",
      PromptModalMessage: add ? "Enter Chapter Name" : "Edit Chapter Name",
      PromptModalButtons: [
        { Title: "OK", Method: add ? this.AddChapterCallback : this.ModifyChapterCallback },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "Group Name", value: add ? "" : chapter.Title }],
    });
  };

  ModifyChapterCallback = (inputs) => {
    if (inputs === null) return;
    window.guide_obj.modifyChapter(this._chapter, inputs[0].value);
    this.handleSearchChanged(null, this.state.searchText);
    this.props.update_display();
  };

  AddChapterCallback = (inputs) => {
    if (inputs === null) return;
    window.guide_obj.addChapter(inputs[0].value);
    this.handleSearchChanged(null, this.state.searchText);
    this.props.update_display();
  };

  deleteSection = (chapter, section) => {
    this.MyAlert("Confirmation", "Confirm Delete Section?", [
      { Title: "OK", Method: () => this._deleteSection(chapter, section) },
      { Title: "CANCEL", Method: null },
    ]);
  };

  _deleteSection = (chapter, section) => {
    window.guide_obj.deleteSection(chapter.ID, section);
    this.handleSearchChanged(null, this.state.searchText);
    this.props.update_display();
  };

  _section = null;
  addModifySection = (add, chapter, section) => {
    this._section = section;
    this._chapter = chapter;
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "Section",
      PromptModalMessage: add ? "Enter Section Name" : "Edit Section Name",
      PromptModalButtons: [
        { Title: "OK", Method: add ? this.AddSectionCallback : this.ModifySectionCallback },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "Section Name", value: add ? "" : section.Title }],
    });
  };

  ModifySectionCallback = (inputs) => {
    let new_section = JSON.parse(JSON.stringify(this._section));
    new_section.Title = inputs[0].value;
    window.guide_obj.modifySection(this._chapter.ID, this._section, new_section);
    this.handleSearchChanged(null, this.state.searchText);
    this.props.update_display();
  };

  AddSectionCallback = (inputs) => {
    let new_section = new Section(window.guide_obj.chapters, inputs[0].value);
    new_section.Title = inputs[0].value;
    new_section.html = "";
    window.guide_obj.addSection(this._chapter.ID, new_section);
    this.handleSearchChanged(null, this.state.searchText);
    this.props.update_display();
  };

  editSection = (chapter, section) => {
    console.log("editSection", chapter, section);
    this._section = section;
    this._chapter = chapter;
    let html = section.html;
    if (typeof html == "undefined") html = "";
    this.setState({ HTMLEditorModalContent: html, HTMLEditorModalShow: true });
  };

  editSectionCallback = (html) => {
    let new_section = JSON.parse(JSON.stringify(this._section));
    new_section.html = html;
    window.guide_obj.modifySection(this._chapter.ID, this._section, new_section);
  };

  render() {
    if (window.guide_obj == null) return null;
    let chapterSections = window.guide_obj.getChaptersSectionsToDisplay();
    if (this.state.AlertModalShow)
      return (
        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />
      );
    if (this.state.PromptModalShow)
      return (
        <PromptModal
          show={this.state.PromptModalShow}
          onHide={() => this.setState({ PromptModalShow: false })}
          PromptModalTitle={this.state.PromptModalTitle}
          PromptModalMessage={this.state.PromptModalMessage}
          PromptModalButtons={this.state.PromptModalButtons}
          PromptModalInputs={this.state.PromptModalInputs}
        />
      );
    if (this.state.HTMLEditorModalShow)
      return (
        <HTMLEditorModal
          show={this.state.HTMLEditorModalShow}
          onHide={() => this.setState({ HTMLEditorModalShow: false })}
          html={this.state.HTMLEditorModalContent}
          callback={this.editSectionCallback}
          callback_rt={null}
        />
      );

    return (
      <div className="modal">
        <Modal
          {...this.props}
          dialogClassName="sd-dialog"
          aria-labelledby="contained-modal-title-vcenter"
          centered={false}
          scrollable={false}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="sd-shell">

              {/* ── Header ── */}
              <div className="sd-header">
                <div className="sd-header-icon">
                  <FontAwesomeIcon icon={solid("layer-group")} />
                </div>
                <h2 className="sd-title">Sections</h2>
                <button className="sd-close" onClick={this.props.onHide}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              {/* ── Search row ── */}
              <div className="sd-search-row">
                <div className="sd-search">
                  <FontAwesomeIcon icon={solid("magnifying-glass")} className="sd-search-icon" />
                  <input
                    type="text"
                    placeholder="Search"
                    value={this.state.searchText}
                    onChange={this.handleSearchChanged}
                  />
                </div>
                {this.props.mode === "edit" ? (
                  <button
                    className="sd-add-btn"
                    title="Add Chapter"
                    onClick={() => this.addModifyChapter(true, null)}
                  >
                    <FontAwesomeIcon icon={solid("plus")} />
                  </button>
                ) : null}
              </div>

              {/* ── List ── */}
              <div className="sd-list">
                {this.state.chapterSections.map((chapter, i) => (
                  <div key={i}>
                    {this.props.mode === "edit" ? (
                      <div className="sd-chapter-header">
                        <span className="sd-chapter-title">{chapter.Title}</span>
                        <div className="sd-chapter-actions">
                          <button
                            className="sd-icon-btn"
                            title="Add Section"
                            onClick={() => this.addModifySection(true, chapter, null)}
                          >
                            <FontAwesomeIcon icon={solid("plus")} />
                          </button>
                          <button
                            className="sd-icon-btn"
                            title="Rename Chapter"
                            onClick={() => this.addModifyChapter(false, chapter)}
                          >
                            <FontAwesomeIcon icon={solid("pen")} />
                          </button>
                          <button
                            className="sd-icon-btn danger"
                            title="Delete Chapter"
                            onClick={() => this.deleteChapter(chapter)}
                          >
                            <FontAwesomeIcon icon={solid("trash")} />
                          </button>
                        </div>
                      </div>
                    ) : null}

                    {chapter.data.map((section, index) => (
                      <div
                        key={index}
                        className="sd-item"
                        onClick={() => this.sectionClicked(section)}
                      >
                        <span className="sd-item-label">{section.Title}</span>
                        {this.props.mode === "edit" ? (
                          <div className="sd-item-actions" onClick={(e) => e.stopPropagation()}>
                            <button
                              className="sd-icon-btn"
                              title="Edit section HTML"
                              onClick={() => this.editSection(chapter, section)}
                            >
                              <FontAwesomeIcon icon={solid("code")} />
                            </button>
                            <button
                              className="sd-icon-btn"
                              title="Rename section"
                              onClick={() => this.addModifySection(false, chapter, section)}
                            >
                              <FontAwesomeIcon icon={solid("pen")} />
                            </button>
                            <button
                              className="sd-icon-btn danger"
                              title="Delete section"
                              onClick={() => this.deleteSection(chapter, section)}
                            >
                              <FontAwesomeIcon icon={solid("trash")} />
                            </button>
                          </div>
                        ) : (
                          <span className="sd-item-chevron">
                            <FontAwesomeIcon icon={solid("chevron-right")} />
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>

            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default SectionDialog;
